// Where the spots actually are, in the scroller's own content coordinates.
export type SpotSpan = { readonly left: number; readonly right: number };

// A venue wider than the screen is laid out from its left edge, because `safe
// center` falls back to `start` when the content overflows. That opens the
// floor on a corner of the beach; the middle is what staff expect. §15
//
// The middle of the GRID is not the middle of the floor: a few umbrellas on a
// wide canvas leave the grid's centre on empty sand, and the spots off screen.
export function centredOffset(
  scrollWidth: number,
  clientWidth: number,
  span: SpotSpan | null = null,
): number {
  const middle = span === null ? scrollWidth / 2 : (span.left + span.right) / 2;
  const furthest = Math.max(0, scrollWidth - clientWidth);
  return Math.max(0, Math.min(furthest, Math.round(middle - clientWidth / 2)));
}

// Measured from the tiles themselves, so a floor of any shape opens on itself.
// jsdom draws nothing and answers zero for every box: that reads as no span at
// all, and the grid's own middle stands in. §15
export function spotSpanIn(scroller: HTMLElement): SpotSpan | null {
  const tiles = [...scroller.querySelectorAll('[data-spot-id]')];
  if (tiles.length === 0) return null;
  const origin = scroller.getBoundingClientRect().left - scroller.scrollLeft;
  const left = Math.min(...tiles.map((tile) => tile.getBoundingClientRect().left - origin));
  const right = Math.max(...tiles.map((tile) => tile.getBoundingClientRect().right - origin));
  return right > left ? { left, right } : null;
}
